import React from 'react';
import cx from "classnames";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import SignedInLinks from '../layout/SignedInLinks'
import SignedOutLinks from '../layout/SignedOutLinks'
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import Badge from '@material-ui/core/Badge';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { mainListItems, secondaryListItems } from './listItems';
import SimpleLineChart from './SimpleLineChart';
import SimpleTable from './SimpleTable';
import Navbar from 'components/layout/Navbar'
import { Link } from 'react-router-dom'
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import Sidebar from 'components/layout/Sidebar';
import Footer from "components/footer/Footer";
import image from "assets/img/sidebar-2.jpg";
//import logo from "assets/img/logo-white.svg";
import logo from "assets/img/logo-small.png";
import NavRoutes from 'routes/NavRoutes'
import UserNavRoutes from 'routes/UserNavRoutes'
import DashboardRoutes from "routes/DashboardRoutes"
import { Switch, Route, Redirect } from "react-router-dom";
import { compose } from 'redux';
import { connect } from 'react-redux';
import { signOut, checkProvisioning, checkCompanyOwnership } from 'store/actions/authActions';
import { setAdminView } from 'store/actions/userActions';
import { firebaseConnect } from 'react-redux-firebase';
import { getProjects, openProjectModal, newProject } from 'store/actions/projectActions';
import appStyle from "assets/jss/material-dashboard-pro-react/layouts/dashboardStyle.jsx";
import IconButton from '@material-ui/core/IconButton';
import Hidden from "@material-ui/core/Hidden";
import Modal from 'react-responsive-modal';


const drawerWidth = 240;

const styles = theme => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9,
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    height: '100vh',
    overflow: 'auto',
  },
  chartContainer: {
    marginLeft: -22,
  },
  tableContainer: {
    height: 320,
  },
  h5: {
    marginBottom: theme.spacing.unit * 2,
  },
});

var ps;
class Dashboard2 extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      mobileOpen: false,
      miniActive: false,
      adminViewNotSet: true
    };
    this.resizeFunction = this.resizeFunction.bind(this);
  }
  
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.refs.mainPanel, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", this.resizeFunction);
    
    if (this.props.auth.uid) {
      //this.props.getProjects();
      this.props.history.push({pathname: '/journals'});
    }
      
    
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
    window.removeEventListener("resize", this.resizeFunction);
  }
  componentDidUpdate(e) {
    if (e.history !== undefined && e.history.location.pathname !== e.location.pathname) {
      if (this.refs.mainPanel !== undefined) {
        this.refs.mainPanel.scrollTop = 0;
      }
      if (this.state.mobileOpen) {
        this.setState({ mobileOpen: false });
      }
    }
  }

  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };
  getRoute() {
    return true;
    //return this.props.location.pathname !== "/maps/full-screen-maps";
  }
  sidebarMinimize() {
    this.setState({ miniActive: !this.state.miniActive });
  }


  resizeFunction() {
    if (window.innerWidth >= 960) {
      this.setState({ mobileOpen: false });
    } 
  }

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  
 
  onCloseModal = () => {
    this.props.openProjectModal(false);
  };

  setAdminView = (e) => {
    //this.setState({adminView: adminView, adminViewNotSet: false});
    
    console.log(e);
    if (e.target.id === "adminView") {
      this.props.setAdminView(true);
    } else {
      this.props.setAdminView(false);
    }
    this.setState({adminViewNotSet: false});
    
  };

  handleProjectSubmit = (e) => {
    e.preventDefault();
    if (e.target.projectName === undefined) {
      //show error
      return;
    }
    

    let project = {};
    project.name = e.target.projectName.value;
    project.address = e.target.address !== undefined ? e.target.address.value : "" ;
    project.city = e.target.city !== undefined ? e.target.city.value : "" ;
    project.state = e.target.state !== undefined ? e.target.state.value : "" ;
    project.zip = e.target.zip !== undefined ? e.target.zip.value : "" ;

    this.props.newProject(project);
    this.props.openProjectModal(false);
  }
  
  render() {
    
   
    const { classes, auth, profile, openPrjModal, provisioned, provisionChecked, fbUser, ownedCompaniesChecked, ownedCompanies, adminView, ...rest } = this.props;
    if (!auth.uid) return <Redirect to='/signin' /> 

    if (!provisionChecked) {
      this.props.checkProvisioning(fbUser);
      return <div>Checking provisioning.</div>
    } else if (provisionChecked && !provisioned) {
      return <div>This user is not provisioned to use the dashboard application.<button className="btn green lighten-1 z-depth-0 center" style={{margin: "20px"}} onClick={this.props.signOut}>Sign Out</button></div>
    } else {
      if (!ownedCompaniesChecked) {
        this.props.checkCompanyOwnership(fbUser);
        return <div>Checking privileges.</div>
      } else if ((ownedCompanies.length > 0) && this.state.adminViewNotSet) {
        return (

        <div>
        <Modal open={true} onClose={this.onCloseModal} showCloseIcon={false} center>
        <div style={{display: "flex", flexDirection: "column"}}>
        <button id="adminView" className="btn green lighten-1 z-depth-0 center" style={{margin: "20px"}} onClick={this.setAdminView}>Admin View</button>
        
        <button id="userView" className="btn green lighten-1 z-depth-0 center" style={{margin: "20px"}} onClick={this.setAdminView}>User View</button>
        
            </div>
            </Modal>
              </div>
        )
      } else if (this.state.adminViewNotSet) {
        this.setState({adminViewNotSet: false});
      }
    const switchRoutes = (
      <Switch>
        {DashboardRoutes.map((prop, key) => {
          if (prop.redirect)
            return <Redirect from={prop.path} to={prop.pathTo} key={key} />;
          if (prop.collapse)
            return prop.views.map((prop, key) => {
              return (
                <Route path={prop.path} component={prop.component} key={key} />
              );
            });
          return <Route path={prop.path} component={prop.component} key={key} />;
        })}
      </Switch>
    );

    const mainPanel =
      classes.mainPanel + 
      " " +
      cx({
        [classes.mainPanelSidebarMini]: this.state.miniActive,
        [classes.mainPanelWithPerfectScrollbar]:
          navigator.platform.indexOf("Win") > -1
      });

    const ConstruWiseLink = (this.state.open === true ? <Link style={{ fontSize: '40px' }} to='/'>ConstruWise</Link> : <div></div>);

    return (
      
      <div className={classes.wrapper}>
      {(<Sidebar
          routes={adminView ? NavRoutes : UserNavRoutes}
          logoText={"ConstruWise"}
          logo={logo}
          image={image}
          handleDrawerToggle={this.handleDrawerToggle}
          open={this.state.mobileOpen}
          color="blue"
          bgColor="black"
          miniActive={this.state.miniActive}
          {...rest}
      />)}

      
      
        <div className={mainPanel} ref="mainPanel">
        
            
          

          {//<nav className="nav-wrapper grey darken-3" >
          }
            <div className="nav-wrapper grey darken-3" style={{display: 'flex', flexDirection: 'row'}}>
            <Hidden mdUp implementation="css">
          
        
            <IconButton
              
              aria-label="Open drawer"
              onClick={this.handleDrawerToggle}
              className={classNames(
                classes.menuButton,
                this.state.open && classes.menuButtonHidden,
              )}
            >
              <MenuIcon style={{color: "#eeeeee"}}/>
            </IconButton>
            </Hidden>
              {auth.uid ? <SignedInLinks profile={profile} /> : <SignedOutLinks />}
            </div>
          {//</nav>
          }
          
          
          {/* On the /maps/full-screen-maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
          {this.getRoute() ? (
            <div className="z-depth-0">
            
              <div className={classes.container}>{switchRoutes}</div>
            </div>
          ) : (
            <div className={classes.map}>{switchRoutes}</div>
          )}
          {//this.getRoute() ? <Footer fluid /> : null
          }
          
          <div>
            <Modal open={this.props.openPrjModal} onClose={this.onCloseModal} showCloseIcon={false} center>
            
        
          
            
        
        
        <form onSubmit={this.handleProjectSubmit}>
          
          <h3 className="grey-text text-darken-3 center">Project Details</h3>
          
          <div className="input-field">
            <label htmlFor="projectName">Project Name</label>
            <input type="text" id='projectName' name='projectName' onChange={this.handleChange} />
          </div>
          <div className="input-field">
            <label htmlFor="projectAddress">Address</label>
            <input type="text" id='projectAddress' name='projectAddress' onChange={this.handleChange} />
          </div>
          <div className="input-field">
            <label htmlFor="city">City</label>
            <input type="text" id='city' name='city' onChange={this.handleChange} />
          </div>
          <div className="input-field">
            <label htmlFor="state">State</label>
            <input type="text" id='state' name='state' onChange={this.handleChange} />
          </div>
          <div className="input-field">
            <label htmlFor="zip">Zip</label>
            <input type="text" id='zip' name='zip' onChange={this.handleChange} />
          </div>
          
          <div className="input-field center">
            <button className="btn green z-depth-0">Add</button>
            <div className="center red-text">
              { //authError ? <p>{authError}</p> : null 
              }
            </div>
          </div>
          
          
        </form>
      
            </Modal>
          </div>
          
          
        </div>
        
      </div>
          
    );

    /*return (
      <div className={classes.root}>
        <CssBaseline />
        <AppBar
          position="absolute"
          className={classNames(classes.appBar, this.state.open && classes.appBarShift)}
        >
        
          <Toolbar disableGutters={!this.state.open} className={classes.toolbar} style={{display: 'flex', flexDirection: 'row'}}>
            {ConstruWiseLink}
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              onClick={this.handleDrawerOpen}
              className={classNames(
                classes.menuButton,
                this.state.open && classes.menuButtonHidden,
              )}
            >
              <MenuIcon />
            </IconButton>
            
              <Navbar />
            
            <IconButton color="inherit">
              <Badge badgeContent={4} color="secondary">
                <NotificationsIcon />
              </Badge>
            </IconButton>
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          classes={{
            paper: classNames(classes.drawerPaper, !this.state.open && classes.drawerPaperClose),
          }}
          open={this.state.open}
        >
          <div className={classes.toolbarIcon}>
            <IconButton onClick={this.handleDrawerClose}>
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <Divider />
          <List>{mainListItems}</List>
          <Divider />
          <List>{secondaryListItems}</List>
        </Drawer>
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Typography variant="display1" gutterBottom component="h2">
            Orders
          </Typography>
          <Typography component="div" className={classes.chartContainer}>
            <SimpleLineChart />
          </Typography>
          <Typography variant="display1" gutterBottom component="h2">
            Products
          </Typography>
          <div className={classes.tableContainer}>
            <SimpleTable />
          </div>
        </main>
      </div>
    );*/
        }
      }
  
}

Dashboard2.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) => {
  return {
    getProjects: () => dispatch(getProjects()),
    openProjectModal: (open) => dispatch(openProjectModal(open)),
    newProject: (project) => dispatch(newProject(project)),
    signOut: () => dispatch(signOut()),
    checkProvisioning: (user) => dispatch(checkProvisioning(user)),
    checkCompanyOwnership: (user) => dispatch(checkCompanyOwnership(user)),
    setAdminView: (adminView) => dispatch(setAdminView(adminView))
  }
}

const mapStateToProps = (state) => {
  const fbUser = state.firebase.data.users === undefined ? null : state.firebase.data.users[state.firebase.auth.uid];
  return {
    
    auth: state.firebase.auth,
    profile: state.firebase.profile,
    projects: state.project.projects,
    openPrjModal: state.project.openProjectModal,
    provisioned: state.auth.provisioned,
   ownedCompaniesChecked: state.auth.ownedCompaniesChecked,
   ownedCompanies: state.auth.ownedCompanies,
    provisionChecked: state.auth.provisionChecked,
    fbUser: fbUser,
    adminView: state.user.adminView
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(appStyle),
    firebaseConnect([
      {path: 'users'}
    ]))(Dashboard2);



// WEBPACK FOOTER //
// ./src/components/dashboard/Dashboard2.js